export class MaintenanceOrderSuppliesModel {
    maintenanceOrderSuppliesId: number = 0;
    maintenanceOrderId: number = 0;
    articleId: number = 0;
    mainArticleId: number = 0;
    quantity: number = 0;
    createDate: string = "";
    userNameCreate: string = "";
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}